// extracted by mini-css-extract-plugin
export default {"tagList":"TagList_tagList_mRTDb","small":"TagList_small_1wq3r","activeItem":"TagList_activeItem_3OhQt"};